import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import throttle from 'syf-js-utilities/helpers/throttle';
import { H2 } from '../../typography';
import { checkExpiration, getExpiredDate } from './helpers';
import { ActionButton, Content, CountdownBar, CountdownTime, Header, IconWrapper, Modal } from './subcomponents';
const textDefaults = {
    modalTitle: 'Session Timeout',
    promptTitle: 'Are you still there?',
    countdownWarning: 'Your online session will expire in',
    continueButton: "I'm still here",
    signOffButton: 'Sign Off',
    seconds: 'seconds'
};
const FIFTEEN_MINUTES = 15 * 60;
const InactivityTimer = ({ className, children, headerRef, expiryTime = FIFTEEN_MINUTES, isLoggedIn, newActivityHandler, logoutHandler, durationSeconds = 180, messageType, icon, throttleTimer = 0, text = textDefaults }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [expireTime, setExpireTime] = useState(getExpiredDate(expiryTime));
    const { modalTitle = textDefaults.modalTitle, promptTitle = textDefaults.promptTitle, countdownWarning = textDefaults.countdownWarning, continueButton = textDefaults.continueButton, signOffButton = textDefaults.signOffButton, seconds = textDefaults.seconds } = text;
    const logout = () => {
        logoutHandler();
        setIsOpen(false);
    };
    const resetInactivityTimer = () => {
        if (newActivityHandler) {
            newActivityHandler();
        }
        setExpireTime(getExpiredDate(expiryTime));
        setIsOpen(false);
    };
    /**
     * Registers new activity any time a click occurs
     * anywhere in the consuming app
     */
    useEffect(() => {
        window.addEventListener('click', throttle(resetInactivityTimer, throttleTimer));
        return () => window.removeEventListener('click', resetInactivityTimer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
     * Checks if its time to show the countdown modal
     */
    useEffect(() => {
        if (!isOpen && isLoggedIn) {
            const expirationInterval = setInterval(() => {
                checkExpiration(expireTime, durationSeconds, messageType, isOpen, setIsOpen);
            }, 1000);
            return () => clearInterval(expirationInterval);
        }
        // satisfying 'consistent return' eslint rule
        return undefined;
    }, [durationSeconds, expireTime, messageType, isLoggedIn, isOpen]);
    return (_jsxs(Modal, Object.assign({ headerRef: headerRef, className: className, id: "inactivity-modal", "aria-labelledby": "inactivity-modal-heading", isOpen: isOpen }, { children: [_jsx(Header, { id: "inactivity-modal-heading", headerRef: headerRef, title: modalTitle }), _jsx(CountdownBar, { durationSeconds: durationSeconds }), _jsxs(Content, { children: [icon && _jsx(IconWrapper, { children: icon }), _jsxs("div", { children: [_jsx(H2, Object.assign({ weight: "bold" }, { children: promptTitle })), _jsxs("div", { children: [countdownWarning, _jsx(CountdownTime, { durationSeconds: durationSeconds, action: logout }), ' ', seconds] })] }), children && _jsx("div", { children: children }), _jsxs("div", { children: [_jsx(ActionButton, Object.assign({ "data-type": modalTitle, "data-reason": continueButton, "data-object": "button", "data-analytics": "clicktrackingevent", buttonType: "primary" }, { children: continueButton })), _jsx(ActionButton, Object.assign({ "data-type": modalTitle, "data-reason": signOffButton, "data-object": "button", "data-analytics": "clicktrackingevent", buttonType: "ghost", onClick: logout }, { children: signOffButton }))] })] })] })));
};
export default InactivityTimer;
